<template>
  <v-card
    flat
    outlined
    class="pa-4"
  >
    <v-card-title
      v-if="value.titulo"
      class="subtitle-1 primary--text pa-0 ma-0"
    >
      <span>{{ value.titulo }}</span>
    </v-card-title>
    <v-card-text
      v-show="value.habilitado"
      class="pa-0 ma-0"
    >
      <slot name="body" />
      <v-row>
        <filtro
          v-for="(filho, i) in value.filhos"
          :key="i"
          :value="filho"
        />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Filtro from '@/components/monitoramento/perfil/filtro/base/Filtro';

export default {
  name: 'FiltroBase',

  components: { Filtro },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        habilitado: true,
        filhos: [],
      }),
    },
  },
};
</script>
